export default __webpack_public_path__ + "static/media/critic.56cdcae3.png";